import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { CreateNewModalComponent } from '../../modal/create-new-modal/create-new-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AuthService } from '../../api/auth.service';
import { UserService } from '../../api/user.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  modalRef: any;
  flag: any;
  constructor(
    private router: Router, 
    private formBuilder: FormBuilder, 
    private authService: AuthService,
    private userService: UserService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.loginForm  =  this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  // convenience getter for easy access to form fields
  get f() { return this.loginForm.controls; }
  
  onLogin() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
    this.authService.login(this.loginForm.value).subscribe( res => {
      this.flag=res.flag;
      // if(res.flag == false){
      //   this.router.navigateByUrl('/reset');
      // } 
      // else{
        if(res.token) {
          localStorage.setItem('token', res.token);
          localStorage.setItem('id', res.id);
          this.getUserInfo(+res.id);
        } else {
          this.modalRef = this.modalService.open(CreateNewModalComponent);
          this.modalRef.componentInstance.my_modal_content = ''+res.message;
          this.modalRef.result.then((data: any) => {
            this.router.navigateByUrl('/');
          },);
          console.log("res : ", res);
        }
      // }
    },error =>{
      
    });
  }

  // implement store to save common info
  getUserInfo(id: number) {
    this.userService.getByUserId(id).subscribe(res => {
      if(res.data){ 
        if(this.flag == false){
          this.router.navigateByUrl('/reset');
        }else {
        if(res.data.role == 'admin'){
          localStorage.setItem('userid', res.data.userInfo.user_id);
            const userInfo = { 
              current_status:res.data.current_status,
              role: res.data.role,
              name: res.data.userInfo.name,
              logo: res.data.userInfo.logo,
              id: res.data.userInfo.id,
              userName: res.data.username,
              user_id: res.data.userInfo.user_id
            }
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            this.router.navigateByUrl('/job-orders');
        //  }     
        }
        if(res.data.role == 'isp'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            userinfodata: res.data.userInfo
          }
          console.warn('res : ',res.data);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/service-orders');
        }
        if(res.data.role == 'whuser'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            userinfodata: res.data.userInfo,
            isp_whuser_ids: res.data.isp_whuser_ids,
          }
          console.warn('resw : ',res.data);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/returnofthespares');
        }
        if(res.data.role == 'asm'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            city: res.data.userInfo.city,
            isp_ams_ids: res.data.isp_ams_ids,
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/job-orders');
        }
        if(res.data.role == 'rsm'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            branch_map: res.data.userInfo.branch_map,

           // city: res.data.userInfo.city
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/job-orders');
        }
        if(res.data.role == 'bo'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            branch_office: res.data.userInfo.branch_office,
            city: res.data.userInfo.city
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/isps');
        }
        if(res.data.role == 'ho'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/service-orders');
        } 

        if(res.data.role == 'isps'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            userinfodata: res.data.userInfo
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/dashboard');
        }
        if(res.data.role == 'asms'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            userinfodata: res.data.userInfo
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/dashboard');
        }
	if(res.data.role == 'bsms'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            userinfodata: res.data.userInfo
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/dashboard');
        }
        if(res.data.role == 'rsms'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            userinfodata: res.data.userInfo
          }
          console.warn('res : ',res.data);

          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/dashboard');
        }
        if(res.data.role == 'hos'){
          const userInfo = { 
            role: res.data.role,
            name: res.data.userInfo.name,
            logo: res.data.userInfo.logo,
            id: res.data.userInfo.id,
            userName: res.data.username,
            user_id: res.data.userInfo.user_id,
            userinfodata: res.data.userInfo
          }
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          this.router.navigateByUrl('/dashboard');
        }
      } 
      }
    })
  }

}
